<template>
	<Stone
		:gpv="gpv"
		class="template-stone"
		data-toggle="tooltip"
		data-placement="bottom"
		title="Click to rotate, or drag to move"
	/>
</template>

<script>
import Draggabilly from "draggabilly";

export default {
	props: ["initialDirection", "player"],
	data() {
		return {
			direction: this.initialDirection || 0,
			hasMoved: false
		};
	},
	computed: {
		gpv() {
			return [0, 0, this.direction, this.player];
		}
	},
	methods: {
		rotate(delta) {
			$(".tooltip").tooltip("enable");
			this.direction = this.direction + (delta || 1);
			this.$emit("rotated", this.direction);
		}
	},
	mounted() {
		$('.template-stone[data-toggle="tooltip"]').tooltip();
		const self = this;
		const draggie = new Draggabilly(this.$el, {
			containment: document.getElementById("game-table")
		});
		draggie.on("dragStart", function(event, pointer) {
			$(".tooltip").tooltip("hide");
			$(".tooltip").tooltip("disable");
		});
		draggie.on("dragEnd", function(event, pointer) {
			var newPosition = self.$el.getBoundingClientRect();
			let d = self.direction;
			while (d < 0) d += 4;
			d = d % 4;
			self.$emit("dragend", { newPosition, d, player: self.player });
		});
		draggie.on("staticClick", function(event, pointer) {
			if (event.button == 2) {
				self.rotate(-1);
			} else {
				self.rotate(1);
			}
		});
		this.$el.oncontextmenu = function(e) {
			self.rotate(-1);
			e.preventDefault();
			return false;
		};
	}
};
</script>